import React from 'react'
import CheckboxDescription from './components/CheckboxDescription'

export const createCheckboxViewModel = ({
  activePromotions = []
}) =>
  activePromotions.map((promo, index) => ({
    label: <CheckboxDescription promo={ promo } />,
    value: promo.promotionId,
    name: promo.promotionId
  })
  )

const getRebatesSum = ({
  selectedRebatePromotionsId = [],
  activePromotions = []
}) =>
  activePromotions.filter(promo =>
    selectedRebatePromotionsId.some(value => promo.promotionId === value)
  ).reduce((sum, { rebateSavings = 0 }) => sum + rebateSavings, 0).toFixed(2)

export const getMainInRebatesPrice = ({
  selectedRebatePromotionsId = [],
  activePromotions = [],
  totalAfterSavingsPrice = 0
}) =>
  (totalAfterSavingsPrice - getRebatesSum({ selectedRebatePromotionsId, activePromotions })).toFixed(2)


export const getTotalSavingsPrice = ({
  selectedTirePromotionsId, availablePromotions = []
}) =>
  availablePromotions.reduce((price, promo) =>
    promo.promotionId === selectedTirePromotionsId ? promo.rawTotalWithSavings : price, 0).toFixed(2)
